import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import STree from "@/components/Tree/STree";
import Notice from "@/components/FragmentTemplate/Notice";
import OrgUserTagSelectList from "@/components/FragmentTemplate/OrgUserTagSelectList";
export default {
  name: "ChangeOrgUser",
  components: {
    STree,
    Notice,
    OrgUserTagSelectList
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    scopeList: {
      type: Array,
      default() {
        return [];
      }
    },
    showNotice: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      dataTree: [],
      checkTree: []
    };
  },
  methods: {
    open() {
      this.modal.visible = true;
      this.setValue();
    },
    /* 不显示弹窗 */
    clean() {
      this.checkTree = [];
      this.dataTree = [];
      this.modal.visible = false;
    },
    /* 提交事件 */
    async onCommit() {
      if (this.checkTree.length === 0) {
        this.$Message.success($t("8e3j1c8", "请选择部门/成员"));
        return;
      }
      this.$emit("change", this.checkTree);
      this.clean();
    },
    onSelectChangeTree(item) {
      if (this.checkTree.findIndex(v => v.id === item.id) === -1) {
        item.isCheck = true;
        this.checkTree.push(item);
      } else {
        this.$Message.warning($t("e7dxe3", "已存在"));
      }
    },
    onDelete(item) {
      let index = this.checkTree.findIndex(v => v.id === item.id);
      if (index > -1) {
        item.isCheck = false;
        this.checkTree.splice(index, 1);
      }
    },
    setValue() {
      this.checkTree = [...this.scopeList];
    },
    /*
     ** 递归
     */
    echoCheckDG(data) {
      let change = arr => {
        arr.forEach(v => {
          this.echoCheck(v);
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(data);
    },
    /*
     ** 设置已勾选部门或者成员
     */
    echoCheck(v) {
      let checkTree = this.checkTree;
      let index = checkTree.findIndex(vv => {
        if (vv.type === "USER") {
          return vv.userId === v.userId;
        } else if (vv.type === "ORG") {
          return vv.orgId === v.orgId;
        }
      });
      if (index > -1) {
        v.isCheck = true;
        checkTree[index] = v;
        this.checkTree = [...checkTree];
      }
    }
  }
};